import Vue from 'vue'
import VueRouter from 'vue-router'
import envs from '@/envs'
import Cookies from 'js-cookie'

import Layout from '@/layout/layout.vue'
import Login from '@/layout/login/Login.vue'
import moceanLogin from '@/layout/login/moceanLogin.vue'
import Logout from '@/layout/login/Logout'
import pageNotFound from '@/components/common/error/404'

import {
  getToken
} from '@/utils/token'

import mis from './modules/mis'
import moceanObj  from '@/mocean.js'
import {getFnDecrypt } from '@/api/common/login'


// ─────────────────────────────────────────────────────────────
// 🌐 Cordova Detection and Routing Logic
// ─────────────────────────────────────────────────────────────
//loadMoceanScript()


window.moceanObj = moceanObj

Vue.use(VueRouter)

const createRouter = () => new VueRouter({
  // mode: 'hash',
  routes: [
    {
      path: '/pageNotFound',
      component: pageNotFound,
    },
    {
      path: '/',
      component: Layout,
      children: [
       ...mis,            
      ]
    }, 
    {
      path: '/login',
      name: 'login',
      component: Login
    },       
    {
      path: '/moceanLogin',
      name: 'moceanLogin',
      component: moceanLogin,
      meta: { requiresCordova: true }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '*',
      redirect: '/pageNotFound'
    }
  ]
})

let router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  const token = getToken();
  const isCordova = window.__cordova_init === true;

  if (to.meta.requiresCordova && !isCordova) {
    return next('/login'); // fallback if Cordova not initialized
  }

  // Redirect unauthenticated users from protected pages
  if (!token && !['login', 'moceanLogin'].includes(to.name)) {
    return next('/login');
  }

  next();
});

export default router ;

